import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { items } from './items'

import { useGlobalContext } from '../context';

function SingleProduct() {
    const { id } = useParams();
    const [product, setProduct] = useState({})
    const { addToBag } = useGlobalContext()
    const [productImage, setProductImage] = useState('')


    const thePrd = () => {
        const prd = items.filter((item) => item.id == id)
        setProductImage(prd[0].image[0])
        setProduct(...prd)
    }

    const imgHandler = (imgSrc) => {
        setProductImage(imgSrc)
    }


    useEffect(() => {
        thePrd();
    }, [id])
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    if (product.name) {

        const { id, name, sizes, price, image, inStock } = product;

        return (
            <div className='single-product'>
                <div className="container">


                    <div className="product-images">
                        <img src={productImage} alt="" className="product-img" />
                        <div className="product-small-images">
                            {
                                image.map((img, index) => {
                                    return (
                                        <img src={img} className='product-img-sm' key={index} onClick={() => imgHandler(img)} />
                                    )
                                })
                            }
                        </div>
                    </div>



                    <div className="product-info">
                        <h1 className="product-name">{name}</h1>
                        <h2 className="product-price">
                            {price}<span>LE</span></h2>
                        <h2 className="product-desc">adipisicing elit. Dolorum, incidunt rerum. Accusantium quae esse non iusto.</h2>
                        <ul className="feats">
                            <li className='feat'>Lorem, ipsum.</li>
                            <li className='feat'>Lorem, ipsum dolor.</li>
                            <li className='feat'>Lorem ipsum dolor sit.</li>
                        </ul>
                        <div className="sizes">
                            Sizes:
                            {sizes.map((size, index) => {
                                return (
                                    <li className='size' key={index}>
                                        {size}
                                    </li>
                                )
                            })}
                        </div>
                        <button className="add-to-bag" onClick={() => addToBag(id)}>add to bag</button>
                    </div>
                </div>
            </div>
        )
    } else {
        return ''
    }


}

export default SingleProduct